module.exports = __webpack_public_path__ + "media/images/flags/16/Lithuania-a7aab2ae39bbd048767f65ad7afd0ba4.png";